import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=2d4641f6"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4641f6')) {
      api.createRecord('2d4641f6', component.options)
    } else {
      api.reload('2d4641f6', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=2d4641f6", function () {
      api.rerender('2d4641f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/checkout/components/Register.vue"
export default component.exports